import React from "react";

import StoryblokBasicImage from "../../internal/storyblokBasicImage/StoryblokBasicImage";
import { BackgroundKeyToColor } from "../../../utils/datasources";

import * as styles from "./FactCard.module.scss";


function FactCard({ blok }) {
  const backgroundColor = BackgroundKeyToColor(blok.background_color),
        headingFontColor = BackgroundKeyToColor(blok.heading_font_color),
        textFontColor = BackgroundKeyToColor(blok.text_font_color)

  return (
    <div className={styles.factCard} style={{ backgroundColor: backgroundColor, color: headingFontColor }}>
      <div className={styles.textContent}>
        <h4>{blok.heading}</h4>
        <hr style={{ backgroundColor: headingFontColor, height: 2, opacity: 1 }} />
        <p style={{ color: textFontColor }} className={blok.corner_image && blok.corner_image.filename ? styles.withCornerImage : ""}>{blok.text}</p>
      </div>
      {blok.corner_image && blok.corner_image.filename ? (
        <div className={styles.cornerImage}>
          <StoryblokBasicImage image={blok.corner_image} />
        </div>
      ) : null}
      {blok.bottom_image && blok.bottom_image.filename ? (
        <div className={styles.bottomImage}>
          <StoryblokBasicImage image={blok.bottom_image} />
        </div>
      ) : null}
    </div>
  )
}

export default FactCard;